import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => (
  <footer className="footer-surface pt-12 pb-8 flex flex-col items-center">
    <div className="flex gap-6 text-muted text-base mb-4">
      <Link
        to="/features"
        className="hover:text-accent-400 text-text-muted transition"
      >
        Features
      </Link>
      <Link
        to="/pricing"
        className="hover:text-accent-400 text-text-muted transition"
      >
        Pricing
      </Link>
      <Link
        to="/faq"
        className="hover:text-accent-400 text-text-muted transition"
      >
        FAQ
      </Link>
      <Link
        to="/contact"
        className="hover:text-accent-400 text-text-muted transition"
      >
        Contact
      </Link>
    </div>
    <div className="text-text-muted text-sm flex flex-col items-center">
      <p>&copy; {new Date().getFullYear()} Budiee. All rights reserved.</p>
      <div className="flex gap-3 mt-1">
        <Link
          to="/privacy"
          className="underline hover:text-accent-400 transition"
        >
          Privacy Policy
        </Link>
        <span aria-hidden="true" className="mx-1 text-text-muted font-light">
          |
        </span>
        <Link
          to="/terms"
          className="underline hover:text-accent-400 transition"
        >
          Terms of Service
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
